import { render } from "./MessageWrapper.vue?vue&type=template&id=2ae6421b&scoped=true&ts=true"
import script from "./MessageWrapper.vue?vue&type=script&lang=ts"
export * from "./MessageWrapper.vue?vue&type=script&lang=ts"

import "./MessageWrapper.vue?vue&type=style&index=0&id=2ae6421b&scoped=true&lang=scss"

import exportComponent from "/Users/TomaccioD/Documents/other/nigma-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae6421b"]])

export default __exports__